import { Injectable } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';

@Injectable()
export class ContadoresService {

  constructor(private afDB:AngularFireDatabase) { }

  // Obtiene el contadore de confirmaciones
  public obtenerContadorDeConfirmaciones(){
    return this.afDB.object('/contadores/numeroConfirmaciones/');
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/contadores.service.ts